(function() {
	'use strict';
	angular.module('app.leanProjects')
		.service('leanProjectsService', leanProjectsService);
	
	leanProjectsService.$inject = ['$http', 'hostUrl', 'leanFilterService', 'excelExportService'];
	function leanProjectsService($http, hostUrl, leanFilterService, excelExportService) {
		var urlPfx = '2/factndx/';
		return {
			getProjects: getProjects,
			getStages: getStages,
			deleteProject: deleteProject,
			getCustomFieldList: getCustomFieldList,
			getCustomFieldDropDownList: getCustomFieldDropDownList,
			getExcel:getExcel
		};

		function getExcel(modalScope, extraParams, viewType) {
			var factories = leanFilterService.getFactoryList();
			var url = hostUrl + buildUrl(extraParams, viewType, true);
			return excelExportService.getExcelReportWithGet(leanFilterService.getFactoryList(), url, modalScope);
		}

		function getProjects(extraParams, viewType) {
			var url = hostUrl + buildUrl(extraParams, viewType);
			return $http.get(url).then(getProjectsSuccess).catch(getProjectsFailed);
			
			function getProjectsSuccess(response) {
				return response.data;
			}
			
			function getProjectsFailed(error) {
				return [];
			}
		}
		
		function getStages(factoryId) {
			factoryId = factoryId || globalConfig.factory.id;
			var url = hostUrl + '2/Dimensions/factndx/' + factoryId + '/LeanProjects/Stages';

			return $http.get(url)
				.then(getStagesComplete)
				.catch(getStagesFailed);

			function getStagesComplete(response) {
				return response.data;
			}

			function getStagesFailed(error) {
				return undefined;
			}
		}

		function deleteProject(projNdx, factoryId) {
			if (!factoryId) factoryId = globalConfig.factory.id;
			var url = hostUrl + '2/factndx/' + factoryId + '/LeanProject/' + projNdx;
			
			return $http.delete(url)
				.then(deleteProjectSuccess)
				.catch(deleteProjectFailed);
			
			function deleteProjectSuccess(response) {
				return response;
			}
			
			function deleteProjectFailed(error) {
				return error;
			}
		}
		
		function getCustomFieldList() {
			var url = hostUrl + '2/companyId/' + globalConfig.customer.id + '/Projects/CustomFields';
			return $http.get(url)
				.then(getCustomFieldListComplete)
				.catch(getCustomFieldListFailed);
			
			function getCustomFieldListComplete(response) {
				return response.data;
			}
			
			function getCustomFieldListFailed(error) {
				return [];
			}
		}
		
		function getCustomFieldDropDownList(fieldNdx) {
			var url = hostUrl + '2/companyId/' + globalConfig.customer.id + '/Projects/CustomDropDownField/' + fieldNdx;
			return $http.get(url)
				.then(getCustomFieldDropDownListComplete)
				.catch(getCustomFieldDropDownListFailed);
			
			function getCustomFieldDropDownListComplete(response) {
				return response.data;
			}
			
			function getCustomFieldDropDownListFailed(error) {
				return [];
			}
		}
		
		function buildUrl(extraParams, viewType, isExcel) {
			var factories;
			if (viewType === 'projectSearch') {
				factories = '';
				var factoryList = leanFilterService.getFilterById('factory').objectList;
				angular.forEach(factoryList, function(fact) {
					factories += fact.id + ',';
				});
				factories = factories.substring(0, factories.length - 1);
			} else {
				factories = leanFilterService.getFactoryList();
			}
			var url = urlPfx + factories + (typeof isExcel !== 'undefined' && isExcel ? '/ExcelReports/LeanProject' : '/LeanProjects');
			url = addFilterQueryParams(url, extraParams);
			return url;
		}

		function addFilterQueryParams(url, extraParams) {
			extraParams.push({'key':'includeAllStages', 'value':true});
			var filterQueryParam = leanFilterService.getQueryParam();
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1)
				qParams = '?' + parts[1];
			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			for (var i = 0; i < extraParams.length; i++) {
				qParams = appendQueryParam(qParams, extraParams[i].key, extraParams[i].value);
			}
			return parts[0] + qParams;
		}
	}
})();